module.exports = __webpack_public_path__ + "static/media/curve.ef360ab1.svg";